
import { defineComponent, reactive, watch } from 'vue';
import Icone from '@/core/components/Icone.vue';
import Card from '@/core/components/Tela/Card.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import SelecionarEmpresa from '@/components/MeuSistema/Empresas/SelecionarEmpresa.vue';
import SelecionarUsuario from '@/components/MeuSistema/Usuarios/SelecionarUsuario.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import SelecionarEstoque from '@/components/Cadastros/Estoques/SelecionarEstoque.vue';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import ProdutoDetalhes from '@/components/Cadastros/Produtos/ProdutoDetalhes.vue';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { ITransferenciaEstoque } from '@/models/Entidades/Estoques/ITransferenciaEstoque';
import ServicoTransferenciaEstoque from '@/servicos/Estoques/ServicoTransferenciaEstoque';
import storeSistema from '@/store/storeSistema';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import ServicoUnidade from '@/servicos/Cadastros/Produtos/ServicoUnidade';
import { IUnidade } from '@/models/Entidades/Cadastros/Produtos/IUnidade';
import ServicoEstoque from '@/servicos/Cadastros/Estoques/ServicoEstoque';
import { IEstoqueItem } from '@/models/Entidades/Cadastros/Estoques/IEstoqueItem';
import { IDTOProdutoDefinicao } from '@/models/DTO/Cadastros/Produtos/IDTOProdutoDefinicao';
import { IDTORastreabilidade } from '@/models/DTO/Estoques/Rastreabilidade/IDTORastreabilidade';
import { IMovimentoRastreabilidade, IRastreabilidade } from '@/models/Entidades/Estoques/IRastreabilidade';
import { ETipoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoRastreabilidade';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { useGradeBase } from '@/core/composables/GradeBase';
import { IParametroConsultaRastreabilidade } from '@/models/ParametrosRequisicao/Estoques/IParametroConsultaRastreabilidade';
import { ETipoLancamentoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoLancamentoRastreabilidade';
import ServicoRastreabilidade from '@/servicos/Estoques/ServicoRastreabilidade';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { ETipoUsoArma } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoUsoArma';
import { IEstoque } from '@/models/Entidades/Cadastros/Estoques/IEstoque';

export default defineComponent({
  name: 'TransferenciaEstoqueModal',
  props: {
    visivel: {
      type: Boolean,
    },
  },
  components: {
    Icone,
    Card,
    CampoNumerico,
    SelecionarData,
    SelecionarEmpresa,
    SelecionarUsuario,
    SelecionarProduto,
    SelecionarEstoque,
    RequisicaoModal,
    ProdutoDetalhes,
  },
  emits: ['sincronizarRegistro', 'update:visivel'],
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemSucesso, apresentarMensagemAlerta } = useTelaBase();
    const {
      modalBase, apresentarRetornoRequisicao, apresentarBarraProgresso, ocultarBarraProgresso,
    } = useModalBase(props, emit);
    const { gradeBase, carregarPreferenciasGrade } = useGradeBase();
    const servicoTransferenciaEstoque = new ServicoTransferenciaEstoque();
    const servicoEstoque = new ServicoEstoque();
    const servicoProduto = new ServicoProduto();
    const servicoRastreabilidade = new ServicoRastreabilidade();
    const state = reactive({
      codigo: 0,
      definicaoProduto: {} as IDTOProdutoDefinicao,
      rastreabilidades: [] as IDTORastreabilidade[],
      rastreabilidadesSelecionadas: [] as IRastreabilidade[],
      transferenciaEstoque: {} as ITransferenciaEstoque,
      tipoRastreabilidade: ETipoRastreabilidade.Nenhum,
      estoque: {} as IEstoque,
      estoqueItem: {} as IEstoqueItem,
      apresentarDetalhesProduto: false,
      quantidadeAtualOrigem: 0,
      quantidadeBloqueadaOrigem: 0,
      quantidadeAposTransferenciaOrigem: 0,
      quantidadeAtualDestino: 0,
      quantidadeBloqueadaDestino: 0,
      quantidadeAposTransferenciaDestino: 0,
      unidadesCadastradas: [] as IUnidade[],
      unidadeProduto: {} as IUnidade,
      buscandoInformacoesEstoqueOrigem: false,
      buscandoInformacoesEstoqueDestino: false,
      qtdTotalSelecionada: 0,
      buscaRapida: '',
      itemMovimento: 0,
      quantidade: 0,
      qtdTtotalSelecionada: 0,
      tipoLancamento: ETipoLancamentoRastreabilidade.Manual,
      recurso: '',
      empresa: 0,
      identificadorSelecionado: '',
      qtdSelecionada: 0,
      rastreabilidadeSelecionada: -1,
      edicao: false,
      codigoUsuario: storeSistema.getters.codigoUsuarioAutenticado(),
      codigoEmpresaOrigem: storeSistema.getters.codigoEmpresaOperacao(),
      codigoEmpresaDestino: storeSistema.getters.codigoEmpresaOperacao(),
      codigoProdutoDefinicao: 0,
      codigoEstoqueOrigem: 0,
      codigoEstoqueDestino: 0,
      codigoEstoqueItemOrigem: 0,
      codigoEstoqueItemDestino: 0,
      quantidadeTransferir: 0,
      dataTransferencia: UtilitarioData.obterDataAtual(),
    });

    (async () => {
      state.unidadesCadastradas = await new ServicoUnidade().obterTodasUnidades(storeSistema.getters.empresasUsuarioAutenticado());
      state.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.definicaoProduto.codigoDefinicao = state.transferenciaEstoque.codigoProdutoDefinicao;
    })();

    async function objetoInicial() {
      state.transferenciaEstoque = {} as ITransferenciaEstoque;
      state.transferenciaEstoque.codigo = 0;
      state.transferenciaEstoque.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.transferenciaEstoque.dataTransferencia = await new ServicoSistema().obterDataAtual();
      telaBase.empresasSelecionadas = [];
      telaBase.empresasSelecionadas = storeSistema.getters.empresasUsuarioAutenticado();
      state.unidadeProduto = {} as IUnidade;
      state.unidadeProduto.codigo = 0;
      state.unidadeProduto.casasDecimais = 0;
      state.unidadeProduto.descricao = '';
      state.unidadeProduto.sigla = '';
      state.definicaoProduto = {} as IDTOProdutoDefinicao;
      state.codigoEstoqueOrigem = 0;
      state.codigoEstoqueDestino = 0;
      state.codigoEstoqueItemOrigem = 0;
      state.codigoEstoqueItemDestino = 0;
      state.qtdSelecionada = 0;
      state.qtdTotalSelecionada = 0;
      state.quantidadeAposTransferenciaDestino = 0;
      state.quantidadeAposTransferenciaOrigem = 0;
      state.quantidadeAtualDestino = 0;
      state.quantidadeAtualOrigem = 0;
      state.quantidadeTransferir = 0;
      if (telaBase.empresasSelecionadas.length === 1) {
        state.transferenciaEstoque.codigoEmpresaDestino = telaBase.empresasSelecionadas[0];
        state.transferenciaEstoque.codigoEmpresaOrigem = telaBase.empresasSelecionadas[0];
      }
      state.transferenciaEstoque.rastreabilidades = [];
      state.rastreabilidades = [];
      state.codigoProdutoDefinicao = 0;
    }

    function preencherRastreabilidadesSelecionadas() {
      state.transferenciaEstoque = {} as ITransferenciaEstoque;
      state.transferenciaEstoque.codigo = state.codigo;
      state.transferenciaEstoque.codigoProdutoDefinicao = state.definicaoProduto.codigoDefinicao;
      state.transferenciaEstoque.codigoUsuario = state.codigoUsuario;
      state.transferenciaEstoque.dataTransferencia = state.dataTransferencia;
      state.transferenciaEstoque.codigoEmpresaOrigem = state.codigoEmpresaOrigem;
      state.transferenciaEstoque.codigoEmpresaDestino = state.codigoEmpresaDestino;
      state.transferenciaEstoque.codigoEstoqueOrigem = state.codigoEstoqueOrigem;
      state.transferenciaEstoque.codigoEstoqueDestino = state.codigoEstoqueDestino;
      state.transferenciaEstoque.transferencia = state.qtdTotalSelecionada;
      state.transferenciaEstoque.dataTransferencia = state.dataTransferencia;
      state.transferenciaEstoque.codigoEstoqueItemDestino = state.codigoEstoqueItemDestino;
      state.transferenciaEstoque.codigoEstoqueItemOrigem = state.codigoEstoqueItemOrigem;
      state.transferenciaEstoque.rastreabilidades = [];
      state.rastreabilidades.forEach((item) => {
        if (state.definicaoProduto.tipoRastreabilidade !== ETipoRastreabilidade.Nenhum && item.qtdSelecionada > 0) {
          const rastreabilidade: IRastreabilidade = {
            codigoItemMovimento: 0,
            codigo: item.codigo,
            codigoItemEstoque: item.codigoItemEstoque,
            identificador: item.quantidade !== item.qtdSelecionada ? '' : item.identificador,
            descricao: item.descricao,
            dataCriacao: UtilitarioData.obterDataAtual(),
            tipo: ETipoRastreabilidade.Lote,
            observacao: item.observacao,
            rastreabilidadeLote: {
              codigo: item.codigo,
              codigoRastreabilidade: item.codigo,
              numeroLote: item.numeroLote,
              dataFabricacao: item.dataFabricacao,
              dataValidade: item.dataValidade,
              precoMaximoConsumidor: item.precoMaximoConsumidor,
              densidade: 0,
              controles: item.controles,
            },
            visivel: true,
            qtdRastreabilidade: item.qtdSelecionada,
            movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
            rastreabilidadeArmamento: {
              codigo: 0,
              codigoRastreabilidade: 0,
              descricao: '',
              tipoUsoArma: ETipoUsoArma.UsoRestrito,
              numeroSerieArma: '',
              numeroSerieCano: '',
            },
            origem: {
              quantidade: item.qtdSelecionada,
              codigo: 0,
              codigoRastreabilidade: 0,
              codigoMovimento: 0,
              recurso: '',
            },
          };
          state.transferenciaEstoque.rastreabilidades.push(rastreabilidade);
        }
      });
    }

    async function transferirEstoque() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      preencherRastreabilidadesSelecionadas();
      state.transferenciaEstoque.transferencia = state.qtdTotalSelecionada;
      apresentarBarraProgresso();

      retorno = await servicoTransferenciaEstoque.transferirEstoque(state.transferenciaEstoque);

      ocultarBarraProgresso();

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        modalBase.computedVisivel = false;
      } else {
        apresentarRetornoRequisicao(retorno);
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      if (modalBase.computedVisivel) {
        await objetoInicial();
      }
    });

    async function obterDadosIdentificacaoDefinicao(codigoDefinicao:number) {
      if (UtilitarioGeral.validaCodigo(codigoDefinicao)) {
        const dadosIdentificacaoApi = await new ServicoProduto().obterDadosIdentificacaoDefinicao(codigoDefinicao);
        if (UtilitarioGeral.objetoValido(dadosIdentificacaoApi)) {
          state.definicaoProduto.codigoDefinicao = dadosIdentificacaoApi.codigoDefinicao;
          state.definicaoProduto.tipoRastreabilidade = dadosIdentificacaoApi.tipoRastreabilidade || ETipoRastreabilidade.Nenhum;
          const unidade = state.unidadesCadastradas.find((c) => c.codigo === dadosIdentificacaoApi.codigoUnidade);
          if (unidade !== undefined && unidade !== null) {
            state.unidadeProduto = unidade;
          }
        }
      }
    }

    function preencherColunas() {
      switch (state.definicaoProduto.tipoRastreabilidade) {
        case ETipoRastreabilidade.Nenhum:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoItemEstoque', key: 'codigoItemEstoque', position: 1, visible: false,
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 2, visible: false, ordering: false, align: 'left', width: 140,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'descricaoEstoque', position: 3, visible: true, ordering: true, align: 'left', width: 250,
            },
            {
              title: 'Qtd Disponível', dataIndex: 'quantidade', key: 'quantidade', position: 4, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 5, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Ações', key: 'acoes', position: 6, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        case ETipoRastreabilidade.Outros:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoEstoque', key: 'codigoEstoque', position: 1, visible: false,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'DescricaoEstoque', position: 2, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 3, visible: true, ordering: true, align: 'left', width: 100,
            },
            {
              title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Qtd Disponível', dataIndex: 'quantidade', key: 'quantidade', position: 5, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 6, visible: true, ordering: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Açoes', key: 'acoes', position: 8, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        case ETipoRastreabilidade.Lote:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoEstoque', key: 'codigoEstoque', position: 1, visible: false,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'DescricaoEstoque', position: 2, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 3, visible: true, ordering: false, align: 'left', width: 140,
            },
            {
              title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true, ordering: false, align: 'left',
            },
            {
              title: 'Qtd Disponível', dataIndex: 'quantidade', key: 'quantidade', position: 5, visible: true, ordering: false, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 6, visible: true, ordering: false, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Nº do Lote', dataIndex: 'numeroLote', key: 'NumeroLote', position: 7, visible: true, ordering: false, align: 'center', width: 100,
            },
            {
              title: 'Validade', dataIndex: 'dataValidade', key: 'DataValidade', position: 8, visible: true, ordering: true, align: 'center', width: 100,
            },
            {
              title: 'Açoes', key: 'acoes', position: 9, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        case ETipoRastreabilidade.Armamento:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoEstoque', key: 'codigoEstoque', position: 1, visible: false,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'DescricaoEstoque', position: 2, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 3, visible: true, ordering: true, align: 'left', width: 140,
            },
            {
              title: 'Descrição Rastreabilidade', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Qtd Rastreabilidades', dataIndex: 'quantidade', key: 'quantidade', position: 5, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 6, visible: true, ordering: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Nº Arma', dataIndex: 'numeroSerieArma', key: 'NumeroSerieArma', position: 7, visible: true, ordering: true, align: 'center', width: 100,
            },
            {
              title: 'Nº Cano', dataIndex: 'numeroSerieCano', key: 'NumeroSerieCano', position: 8, visible: true, ordering: true, align: 'center', width: 100,
            },
            {
              title: 'Açoes', key: 'acoes', position: 9, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        default:
          gradeBase.colunasPadrao = [];
          break;
      }
    }

    async function obterCodigoEstoque(codigoEstoque: number, codigoUnidade: number, codigoProduto: number) {
      state.estoque = {} as IEstoque;
      state.estoque = await servicoEstoque.obter(codigoEstoque, state.empresa);
      state.estoqueItem = await servicoEstoque.obterItemEstoqueInformacoesProduto(codigoEstoque, codigoProduto, codigoUnidade, state.empresa);
    }

    async function obterDadosProduto() {
      state.definicaoProduto = await servicoProduto.obterDadosDetalhesDefinicao(state.definicaoProduto.codigoDefinicao);
      preencherColunas();
      carregarPreferenciasGrade(telaBase.preferencias);
      await obterCodigoEstoque(state.codigoEstoqueOrigem, state.unidadeProduto.codigo, state.definicaoProduto.codigoDefinicao);
      const parametros = {} as IParametroConsultaRastreabilidade;
      state.rastreabilidadesSelecionadas = [];
      parametros.codigoItemEstoque = state.estoqueItem.codigo;
      parametros.codigoMovimento = state.itemMovimento;
      parametros.codigoProdutoDefinicao = state.definicaoProduto.codigoDefinicao;
      parametros.quantidadeProduto = state.quantidade;
      parametros.tipoLancamento = ETipoLancamentoRastreabilidade.Manual;
      parametros.tipoRastreabilidade = state.definicaoProduto.tipoRastreabilidade;
      parametros.empresas = [state.empresa];
      parametros.recurso = state.recurso;
      state.rastreabilidades = await servicoRastreabilidade.obterRastreabilidadesProduto(parametros);
      state.qtdTotalSelecionada = 0;
      if (state.rastreabilidades.length > 0) {
        state.quantidadeAtualOrigem = 0;
        state.rastreabilidades.forEach((r) => {
          state.quantidadeAtualOrigem += r.quantidade;
          // eslint-disable-next-line no-param-reassign
          r.qtdSelecionada = 0;
        });
      }
    }

    function validarCampos() {
      if (state.identificadorSelecionado === '' || state.identificadorSelecionado === undefined) {
        apresentarMensagemAlerta('O identificador deve ser informado!');
        return false;
      }
      const indexRast = state.rastreabilidades.findIndex((r) => r.identificador === state.identificadorSelecionado);
      if (indexRast === -1) {
        apresentarMensagemAlerta('Nenhum estoque / rastreabilidade com o identificador informado!');
        return false;
      }

      if (state.rastreabilidades[indexRast].quantidade < state.qtdSelecionada) {
        apresentarMensagemAlerta('A quantidade selecionada não pode ser maior que a quantidade disponível do estoque / rastreabilidade');
        return false;
      }

      let qtd = state.qtdSelecionada + state.qtdTotalSelecionada;
      if (state.edicao) {
        const qtdAtual = state.rastreabilidades[indexRast].qtdSelecionada;
        if (qtdAtual === state.qtdSelecionada) {
          return true;
        }
        if (qtdAtual < qtd) {
          qtd = state.qtdTotalSelecionada - state.qtdSelecionada;
        }
      }
      return true;
    }

    function adicionar() {
      if (!validarCampos()) return;
      const indexRast = state.rastreabilidades.findIndex((r) => r.identificador === state.identificadorSelecionado);
      if (state.rastreabilidadeSelecionada === -1) {
        state.rastreabilidades[indexRast].qtdSelecionada += state.qtdSelecionada;
      } else {
        state.rastreabilidades[indexRast].qtdSelecionada = state.qtdSelecionada;
      }
      if (state.rastreabilidadeSelecionada !== -1) {
        state.rastreabilidades[state.rastreabilidadeSelecionada].qtdSelecionada = state.qtdSelecionada;
      }
      state.qtdSelecionada = 0;
      state.identificadorSelecionado = '';
      state.rastreabilidadeSelecionada = -1;

      state.qtdTotalSelecionada = 0;
      state.rastreabilidades.forEach((r) => {
        state.qtdTotalSelecionada += r.qtdSelecionada;
      });
      state.edicao = false;
    }
    async function buscarInformacoesEstoqueOrigem() {
      state.buscandoInformacoesEstoqueOrigem = true;
      state.quantidadeAtualOrigem = 0;
      state.codigoEstoqueItemOrigem = 0;

      if (!UtilitarioGeral.validaCodigo(state.codigoProdutoDefinicao)) {
        apresentarMensagemAlerta('É necessário selecionar um produto!');
        return;
      }

      if (!UtilitarioGeral.validaCodigo(state.codigoEmpresaOrigem)) {
        apresentarMensagemAlerta('É necessário selecionar a empresa de origem!');
        return;
      }

      if (!UtilitarioGeral.validaCodigo(state.codigoEstoqueOrigem)) {
        apresentarMensagemAlerta('É necessário selecionar o estoque de origem!');
        return;
      }

      const estoqueItem = await servicoEstoque.obterItemEstoqueInformacoesProduto(state.codigoEstoqueOrigem,
        state.codigoProdutoDefinicao, state.unidadeProduto.codigo,
        state.codigoEmpresaOrigem);

      if (estoqueItem !== undefined) {
        if (estoqueItem.codigo > 0) {
          state.codigoEstoqueItemOrigem = estoqueItem.codigo;
          await obterDadosProduto();
        }
      } else {
        apresentarMensagemAlerta('Produto sem quantidades disponíveis neste estoque!');
      }

      state.buscandoInformacoesEstoqueOrigem = false;
    }

    async function buscarInformacoesEstoqueDestino() {
      state.buscandoInformacoesEstoqueDestino = true;
      state.quantidadeAtualDestino = 0;
      state.codigoEstoqueItemDestino = 0;

      if (!UtilitarioGeral.validaCodigo(state.codigoProdutoDefinicao)) {
        apresentarMensagemAlerta('É necessário selecionar um produto!');
        return;
      }

      if (!UtilitarioGeral.validaCodigo(state.codigoEmpresaDestino)) {
        apresentarMensagemAlerta('É necessário selecionar a empresa de destino!');
        return;
      }

      if (!UtilitarioGeral.validaCodigo(state.codigoEstoqueDestino)) {
        apresentarMensagemAlerta('É necessário selecionar o estoque de destino!');
        return;
      }

      let estoqueItem = await servicoEstoque.obterItemEstoqueInformacoesProduto(state.codigoEstoqueDestino,
        state.codigoProdutoDefinicao, state.unidadeProduto.codigo,
        state.codigoEmpresaDestino);

      if (!UtilitarioGeral.objetoValido(estoqueItem)) {
        estoqueItem = {} as IEstoqueItem;
        estoqueItem.codigo = 0;
        estoqueItem.codigoEmpresa = state.codigoEmpresaDestino;
        estoqueItem.codigoEstoque = state.codigoEstoqueDestino;
        estoqueItem.codigoProdutoDefinicao = state.codigoProdutoDefinicao;
        estoqueItem.codigoUnidade = state.unidadeProduto.codigo;
        estoqueItem.bloqueado = false;

        const retornoItemEstoque = await servicoEstoque.incluirItens(state.codigoEstoqueDestino, [estoqueItem]);
        if (retornoItemEstoque.status === EStatusRetornoRequisicao.Sucesso) {
          state.codigoEstoqueItemDestino = retornoItemEstoque.codigoRegistro;
        } else {
          apresentarMensagemAlerta(retornoItemEstoque.mensagem);
        }
      } else if (estoqueItem.codigo > 0) {
        state.codigoEstoqueItemDestino = estoqueItem.codigo;
      }

      if (state.codigoEstoqueItemDestino > 0) {
        state.quantidadeAtualDestino = await servicoEstoque.obterQuantidadeDisponivelItemEstoque(state.codigoEstoqueItemDestino);
      }
      state.buscandoInformacoesEstoqueDestino = false;
    }

    function filtrar() {
      state.rastreabilidades.forEach((r, i) => {
        if (state.buscaRapida === '') {
          state.rastreabilidades[i].visivel = true;
        } else if (state.buscaRapida.toUpperCase().includes(r.identificador.toUpperCase()) || state.buscaRapida.toUpperCase().includes(r.descricao.toUpperCase()) || state.buscaRapida.toUpperCase().includes(r.numeroLote.toUpperCase()) || state.buscaRapida === UtilitarioData.aplicaFormatoData(r.dataFabricacao)
            || state.buscaRapida === UtilitarioData.aplicaFormatoData(r.dataValidade) || state.buscaRapida.toUpperCase().includes(r.numeroSerieArma.toUpperCase()) || state.buscaRapida.toUpperCase().includes(r.numeroSerieCano.toUpperCase())) {
          state.rastreabilidades[i].visivel = true;
        } else {
          state.rastreabilidades[i].visivel = false;
        }
      });
    }

    function editar(index: number, edicao: boolean) {
      state.identificadorSelecionado = state.rastreabilidades[index].identificador;
      state.qtdSelecionada = state.rastreabilidades[index].qtdSelecionada;
      state.rastreabilidadeSelecionada = index;
      state.edicao = edicao;
    }
    return {
      telaBase,
      gradeBase,
      props,
      modalBase,
      state,
      transferirEstoque,
      objetoInicial,
      obterDadosIdentificacaoDefinicao,
      buscarInformacoesEstoqueOrigem,
      buscarInformacoesEstoqueDestino,
      UtilitarioMascara,
      UtilitarioData,
      obterDadosProduto,
      ETipoRastreabilidade,
      filtrar,
      ECustomRenderRow,
      editar,
      adicionar,
      validarCampos,
    };
  },
});
